/**
 * Temporary CRM/product messaging pivot.
 * Reverted 2026-07-06: pivot OFF — the public landing page, Stylon identity,
 * booking-focused copy, /for business pages, and full pricing/features are
 * restored, and `/` no longer redirects to onboarding. Flip back to `true`
 * only to re-enter the pivot.
 */
export const TEMP_CRM_PIVOT = false;

export const HOME_ONBOARDING_REDIRECT = 'https://portal.stylon.co/onboarding';

/** True during react-snap postbuild — external redirects break Puppeteer. */
export function isPrerenderPass() {
  return (
    typeof navigator !== 'undefined' &&
    /ReactSnap/i.test(navigator.userAgent || '')
  );
}

/** Live visitors only; prerender still snapshots the landing page for `/`. */
export function shouldRedirectHomeFromLanding() {
  return TEMP_CRM_PIVOT && !isPrerenderPass();
}

/** Feature keys omitted from nav, /features, and /guides while pivot is on. */
export const HIDDEN_FEATURE_KEYS = new Set([
  'booking',
  'appointments',
  'reminders',
  'calendar',
  'services',
]);

/** Paths that redirect to CRM overview (not rendered, not in menus). */
export const HIDDEN_FEATURE_PATHS = new Set([
  '/features/online-booking',
  '/features/appointments',
  '/features/reminders',
  '/features/calendar',
  '/features/services',
]);

/** Terms sections hidden during pivot (appointment-specific rules). */
export const HIDDEN_TERMS_SECTION_KEYS = new Set(['section13', 'section15']);

/** Strip appointment/booking phrases from plan benefit lines (API text). */
const BOOKING_BENEFIT_RE = /appointment|booking|calendar|no-?show|specialist|תור|הזמנ|יומן|موعد|حجز|تقويم/i;

export function filterPlanBenefits(features) {
  if (!TEMP_CRM_PIVOT || !Array.isArray(features)) return features;
  return features.filter((f) => !BOOKING_BENEFIT_RE.test(String(f)));
}

export function isHiddenFeatureKey(key) {
  return TEMP_CRM_PIVOT && HIDDEN_FEATURE_KEYS.has(key);
}

export function isHiddenFeaturePath(path) {
  return TEMP_CRM_PIVOT && HIDDEN_FEATURE_PATHS.has(path);
}
